// extracted by mini-css-extract-plugin
export default {"categoryLink":"SideLink_categoryLink__5TIMw"};